import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import CustomStore from 'devextreme/data/custom_store';
import { environment } from 'src/environments/environment';
import { HandleError, HttpErrorHandler } from '../http-error-handler.service';
import { BehaviorSubject } from 'rxjs';
import { MessageResponse } from 'src/app/Interfaces/MessageResponse';
import { NotifyService } from './notify.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeDurationService {
  dataSource: any;
  public customDataSource: any;
  private handleError: HandleError;
  customDataSourceEmployeeDuration: CustomStore;
  $EMPLOYEE_DURATION_ID=new BehaviorSubject<number>(0);
  constructor(private http: HttpClient, public translatee: TranslateService,public NotifyService:NotifyService,
    public httpErrorHandler: HttpErrorHandler) {
    this.handleError = httpErrorHandler.createHandleError('ObjectService');
    const isNotEmpty = (value: any) => value !== undefined && value !== null && value !== '';

    this.customDataSourceEmployeeDuration = new CustomStore({
      key: 'employeeId',
      load: (loadOptions: any) => {
        let params = new HttpParams();
        [
          'requireTotalCount',
          // 'skip',
          // 'take',
        ].forEach(function (i) {
          if (i in loadOptions && isNotEmpty(loadOptions[i])) {
            params = params.append(i, JSON.stringify(loadOptions[i]));
          }

        });
        return this.http.get(`${environment.apiRoot}/api/AssignEmployeeDuration/all`, { params: params })
          .toPromise()
          .then((response: any) => {
            return {
              data: response.data,
              totalCount: response.countRecord,
            };

          })

          .catch(() => { throw 'Data loading error' });
      },

      remove: (key) => {
              return this.http.delete(`${environment.apiRoot}/api/AssignEmployeeDuration/Delete?id=` + encodeURIComponent(key)).toPromise().then((message: MessageResponse) => {
                this.NotifyService.notifyfun('delete')
      
              })
            }

    })
  }

// byKey(key:any,from:any,to:any) {
//     return this.http.get(`${environment.apiRoot}/api/AssignEmployeeDuration/GetDurationWorkSystemByEmployeeId?FromDate=${from}&ToDate=${to}&EmployeeIds=${key}`)
// }
byKey(
  employeeIds: number[],
  from: string,
  to: string,
  jobTitleIds: number[] = [],
  departmentIds: number[] = [],
  workSystemIds: number[] = [],
  managementIds: number[] = [],
  branchIds: number[] = [],
  skip: number = 0,
  take: number = 10
) {
  let params = new HttpParams()
    .set('FromDate', from)
    .set('ToDate', to)
    .set('skip', skip.toString())
    .set('take', take.toString());

  // ✅ Append each Employee ID
  employeeIds.forEach(id => {
    params = params.append('EmployeeIds', id.toString());
  });

  // ✅ Append optional filter arrays
  jobTitleIds.forEach(id => {
    if (id != null) params = params.append('JobTitleIds', id.toString());
  });

  departmentIds.forEach(id => {
    if (id != null) params = params.append('DepartmentIds', id.toString());
  });

  workSystemIds.forEach(id => {
    if (id != null) params = params.append('WorkSystemIds', id.toString());
  });

  managementIds.forEach(id => {
    if (id != null) params = params.append('ManagementIds', id.toString());
  });

  branchIds.forEach(id => {
    if (id != null) params = params.append('BranchIds', id.toString());
  });

  // ✅ Send GET request with query parameters
  return this.http.get(
    `${environment.apiRoot}/api/AssignEmployeeDuration/GetDurationWorkSystemByEmployeeId`,
    { params }
  );
}


addemployee_duration(data:any) {
  return this.http.post(`${environment.apiRoot}/api/AssignEmployeeDuration/AddOrUpdate`,data)
   
}

}